import BaseCollection from "lib/collection";
import BaseModel from "lib/model";

const createCollection = function createCollection(mainIndex = "_id", model) {
    return BaseCollection.extend({
        mainIndex: mainIndex,
        model: model,
    });
};

const RepsModel = BaseModel.extend({
    props: {
        _id: "objectId",

        ref: "objectId",
        email: "string",
        name: "string",
    },
});

const LinesheetsModel = BaseModel.extend({
    props: {
        _id: "objectId",

        linesheet: { type: "objectId", required: true },
        title: "string",
        viewed: { type: "boolean", default: false },

        created_by: { type: "string", required: true },
        created_by_ref: "objectId",
        created_on: "date",
    },
});

const Buyer = BaseModel.extend({
    props: {
        _id: "objectId",
        __ref: "objectId",

        __email: "string",
        __name: "string",

        __last_viewed: "date",
    },
    collections: {
        __reps: createCollection("ref", RepsModel),
        __linesheets: createCollection("linesheet", LinesheetsModel),
    },
});

export default BaseCollection.extend({
    mainIndex: "ref",
    model: Buyer,
});
